exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".no-content-container[data-v-1f090bc2]{margin-top:20px}", ""]);

// exports
